import script from "./ModuleData.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModuleData.vue?vue&type=script&setup=true&lang=ts"

import "./ModuleData.vue?vue&type=style&index=0&id=0daa2832&lang=css"

const __exports__ = script;

export default __exports__